export default __webpack_public_path__ + "static/media/SamsungOne-600_v1.0.5c676f36.ttf";